import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { CTAButton } from '@buoyhealth/common.buoy-button';

import { trackFormSubmitted, trackFormViewed } from './analytics';
import Form, { IForm } from './Form';
import { submitMailchimpForm } from './requests/mailchimp';
import { submitEmailForTranscript } from '../../requests/site_api/transcript';

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.blue[0]};
  padding: 24px;
`;
const Title = styled.p`
  ${({ theme }) => theme.typography.variants.primary.main};
  margin: 0 0 8px;
`;

const ContentContainer = styled.div`
  .Buoy__EmailTranscript__Form {
    margin-bottom: 4px;
  }
  .Buoy__EmailTranscript__Form .Buoy__EmailTranscript__Dialog__TC .MuiGrid-item {
    margin-bottom: 0;
    margin-top: 4px;
    padding-bottom: 16px;
  }
  .Buoy__EmailTranscript__Form .Buoy__EmailTranscript__Dialog__Newsletter .MuiGrid-item {
  }
  .MuiFormControlLabel-root {
    align-items: flex-start;
  }

  .MuiCheckbox-root {
    padding-top: 0;
    padding-left: 0;
  }
`;

interface IEmailTranscriptCardProps {
  handleCardSubmit?: () => void;
  interview: string;
  isVisible: boolean;
  title: string;
}

const Card = ({ handleCardSubmit, interview, isVisible, title }: IEmailTranscriptCardProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (isVisible) {
      trackFormViewed(interview, 'eoi-embedded');
    }
  }, [isVisible]);

  const { control, handleSubmit } = useForm<IForm>({
    defaultValues: {
      email: '',
      termsAgreed: false,
      newsletterAgreed: false,
    },
  });
  const onSubmit = useCallback(
    (data: IForm) => {
      try {
        if (data.termsAgreed) {
          setIsSubmitted(true);
          submitEmailForTranscript({ email: data.email, token: interview });
          trackFormSubmitted(interview, data.newsletterAgreed, 'eoi-embedded');
          handleCardSubmit?.();
          if (data.newsletterAgreed) {
            submitMailchimpForm(data.email);
          }
        }
      } catch {
        setIsSubmitted(false);
        setShowError(true);
      }
      setShowTermsError(!data.termsAgreed);
    },
    [isSubmitted],
  );
  return (
    <Container>
      {isSubmitted ? (
        <div>
          <Title>{'Thank you 🙏'}</Title>
          <Title>
            {'Check your inbox for a copy of your visit today. Hope you feel better soon.'}
          </Title>
        </div>
      ) : (
        <ContentContainer>
          <Title>{title}</Title>
          <Form
            control={control}
            showError={showTermsError}
            showGenericError={showError}
            formType="eoi-embedded"
            interview={interview}
          />
          <CTAButton fullWidth onClick={handleSubmit(onSubmit)} type="submit">
            {'Submit'}
          </CTAButton>
        </ContentContainer>
      )}
    </Container>
  );
};

export default Card;
